module.exports = __webpack_public_path__ + "static/media/team-3.53aa3c0d.avif";